import {trans} from '@frontend/helpers'
import {Input} from 'swayok-react-mdb-ui-kit/components/Input/Input'
import type {AdPropertyConfigForFilters} from '../../../AdsModuleTypes'
import {FilterLabel} from './FilterLabel'

interface Props {
    config: AdPropertyConfigForFilters
    value: unknown
    disabled?: boolean
    onChange: (name: string, value: {min: number | null, max: number | null} | null) => void
}

// Числовой диапазон с независимыми нижней и верхней границами.
export function RangeFilter({config, value, disabled, onChange}: Props) {
    const values = value && typeof value === 'object' && !Array.isArray(value)
        ? value as Record<string, unknown> : {}
    const boundary = (key: string): number | null => {
        const raw = values[key]
        if (raw === '' || raw === null || raw === undefined || !['string', 'number'].includes(typeof raw)) {
            return null
        }
        const number = Number(raw)
        return Number.isFinite(number) ? number : null
    }
    const min = boundary('min')
    const max = boundary('max')
    return (
        <div className="mb-3">
            <FilterLabel
                label={config.props.label}
                showResetButton={min !== null || max !== null}
                disabled={disabled}
                onReset={() => onChange(config.name, null)}
            />
            {(['min', 'max'] as const).map(key => (
                <Input
                    key={key}
                    type="number"
                    small
                    wrapperClassName="mb-2"
                    label={key === 'min' ? trans().ads.list.filters.price_from : trans().ads.list.filters.price_to}
                    value={String((key === 'min' ? min : max) ?? '')}
                    min={typeof config.props.min === 'number' ? config.props.min : undefined}
                    step={typeof config.props.step === 'number' ? config.props.step : 'any'}
                    disabled={disabled}
                    onChange={event => {
                        const number = event.currentTarget.value === '' ? NaN : Number(event.currentTarget.value)
                        const next = {min, max, [key]: Number.isFinite(number) ? number : null}
                        onChange(config.name, next.min === null && next.max === null ? null : next)
                    }}
                />
            ))}
        </div>
    )
}
